import Helper from '@ember/component/helper';

import { service } from '@ember/service';

export default class LinksToStateHelper extends Helper {
  @service routeState;

  compute(routeParams, options) {
    return this.routeState.linkTo(routeParams, options);
  }
}
